export default __webpack_public_path__ + "static/media/ic_down_arrow_blue.0bd60f0c.svg";